// extracted by mini-css-extract-plugin
export default {"wrapper":"RequiredDocuments_style_wrapper__zROP0","description":"RequiredDocuments_style_description__ZAqzD","rotate":"RequiredDocuments_style_rotate__CCUw6"};